module.exports = __webpack_public_path__ + "img/40_38_031_510.34bce4be.jpg";